module.exports = __webpack_public_path__ + "static/media/cohesion_heatmap_1.d268fd39.png";